import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Itinerary from '../components/itinerary/Itinerary';

const ItineraryPage = () => {
  // Get the ID parameter from the URL
  const { id } = useParams();

  // Scroll to top on navigation
  useEffect(() => {
    window.scrollTo(0, 0);
    // Add dark theme class to body when component mounts
    document.body.classList.add('dark-theme');
    
    // Remove dark theme class when component unmounts
    return () => {
      document.body.classList.remove('dark-theme');
    };
  }, [id]);

  // Now you can use the trip ID to fetch data or pass it to your Itinerary component
  return (
    <div className="dark-theme">
      <Itinerary tripId={id} />
    </div>
  );
};

export default ItineraryPage;